// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:37:43

export default {
  "id": "bow-and-arrow",
  "slug": "bow-and-arrow",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/b6ff48a578b042859a4c9e2e322d5bb2-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/b6ff48a578b042859a4c9e2e322d5bb2/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Bow And Arrow",
      "description": "? Bow and Arrow – Master Your Archery Skills! ?\n\nStep into the world of precision shooting in Bow and Arrow! Test your skills, aim with accuracy, and hit your targets in a variety of exciting levels. Whether you're shooting at moving targets, battling enemies, or competing in archery challenges, this game will put your skills to the test!",
      "instructions": "Use your mouse (left side) to shoot ",
      "genres": [
        "Casual",
        "Sports"
      ],
      "tags": [
        "arrow"
      ]
    },
    "zh-CN": {
      "title": "弓箭",
      "description": "弓箭大师——掌握你的射箭技巧！\n\n踏入弓箭的精准射击世界！测试你的技巧，精准瞄准，并在各种激动人心的关卡中命中目标。无论是射击移动目标、与敌人战斗，还是参加射箭挑战，这款游戏将考验你的技能！",
      "instructions": "使用鼠标（左侧）射击",
      "genres": [
        "休闲",
        "运动"
      ],
      "tags": [
        "箭"
      ]
    },
    "zh-TW": {
      "title": "弓箭",
      "description": "弓箭大師 – 磨練你的射箭技巧！\n\n進入弓箭精準射擊的世界！挑戰你的技巧，精準對準，在多種刺激的關卡中擊中目標。無論是射擊移動目標、戰鬥敵人，還是參加射箭挑戰，這款遊戲將檢驗你的技巧！",
      "instructions": "使用您的滑鼠（左邊）來射擊",
      "genres": [
        "休闲",
        "運動"
      ],
      "tags": [
        "箭矢"
      ]
    },
    "zh-HK": {
      "title": "弓箭",
      "description": "? 弓箭 - 磨練你的射箭技巧！ ?\n\n步進弓箭的世界，體驗精準射擊的樂趣！挑戰你的技巧，準確瞄准，在各式各樣刺激的關卡中命中目標。無論是射擊移動目標、戰鬥敵人，或是參與射箭挑戰，這款遊戲將對你的技巧進行極限挑戰！",
      "instructions": "用左邊的滑鼠射擊",
      "genres": [
        "休闲",
        "運動"
      ],
      "tags": [
        "箭矢"
      ]
    },
    "ja": {
      "title": "弓と矢",
      "description": "? 弓と矢 – 弓術のスキルをマスターしよう！ ?\n\n精度の高い射撃の世界にBow and Arrowで踏み込んで！あなたのスキルを試し、正確に狙い、様々なエキサイティングなレベルでのターゲットを射撃しよう。動くターゲットに射撃、敵と戦う、またはアーチェリーのチャレンジに挑戦するなど、このゲームはあなたのスキルを試すためにここにあります！",
      "instructions": "マウス（左側）を使って撃つ",
      "genres": [
        "カジュアル",
        "スポーツ"
      ],
      "tags": [
        "矢"
      ]
    },
    "ko": {
      "title": "총과 화살",
      "description": "? 활과 화살 – 사격 기술을 마스터하세요! ?\n\n활과 화살의 정밀 사격 세계에 걸어 들어보세요! 기술을 테스트하고 정확하게 대상을 맞추고, 다양한 흥미로운 레벨에서 대상을 명중하세요. 움직이는 대상을 사격하거나 적과 싸우거나 사격 도전에서 경쟁하는 것은 무엇이든, 이 게임은 기술을 테스트할 것입니다!",
      "instructions": "마우스(왼쪽)를 사용하여 발사하세요",
      "genres": [
        "캐주얼",
        "스포츠"
      ],
      "tags": [
        "화살矢"
      ]
    },
    "fr": {
      "title": "Arc et Flèche",
      "description": "? Arc et Flèche – Maîtrisez vos compétences en archerie ! ?\n\nPlongez dans le monde du tir de précision dans Arc et Flèche ! Testez vos compétences, vissez avec précision et atteignez vos cibles dans une variété de niveaux captivants. Que vous tirez sur des cibles en mouvement, combattez des ennemis ou participez à des défis d'archerie, ce jeu mettra vos compétences à l'épreuve !",
      "instructions": "Utilisez votre souris (côté gauche) pour tirer",
      "genres": [
        "Facile",
        "Sports"
      ],
      "tags": [
        "flèche"
      ]
    }
  }
};
